import {createAction} from "@reduxjs/toolkit";

export const setInfopage = createAction('SET_INFOPAGE');